import * as THREE from "three";
import { Utils } from "../utils/utils";

declare const Potree: any;

/**
 * Manager responsible for managing point clouds including
 * loading, visibility, and bounding box calculations.
 */
export class PointCloudManager {
	public pointclouds: any[] = [];

	public constructor(private readonly viewer: any) {}

	public async loadPointcloud(url: string, name: string, uuid: string): Promise<any> {
		try {
			const data = await Potree.loadPointCloud(url, "pointcloud");
			if (!data.pointcloud) {
				return null;
			}

			const pointcloud = data.pointcloud;
			pointcloud.name = name;
			if (uuid) {
				pointcloud.uuid = uuid;
			}

			const material = pointcloud.material;
			material.size = 0.5;
			material.minSize = 2.0;
			material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
			material.shape = Potree.PointShape.CIRCLE;
			material.activeAttributeName = "rgba";

			this.viewer.scene.addPointCloud(pointcloud);
			this.pointclouds.push(pointcloud);

			this.viewer.updateLayers();
			this.viewer.updateGroundPosition();
			//Wait one second for pointcloud
			await Utils.delay(1000);

			console.log("Loaded pointcloud", url);

			return pointcloud;
		} catch (e) {
			console.error("Error loading pointcloud:", e);
			return null;
		}
	}

	public showPointClouds(): void {
		for (const pc of this.pointclouds) {
			this.viewer.scene.addPointCloud(pc);
		}
	}

	public hidePointClouds(): void {
		for (const pc of this.pointclouds) {
			this.viewer.scene.scenePointCloud.remove(pc);
		}
	}

	public getBoundingBox(): THREE.Box3 | null {
		if (this.pointclouds.length === 0) return null;
		return this.viewer.getBoundingBoxForObjects(this.pointclouds);
	}

	public findById(id: string): any | undefined {
		return this.pointclouds.find((m) => m.uuid == id);
	}

	public cleanup(): void {
		while (this.viewer.scene.pointclouds.length > 0) {
			const pc = this.viewer.scene.pointclouds[0];
			this.viewer.scene.pointclouds.splice(0, 1);
			this.viewer.scene.scenePointCloud.remove(pc);
		}

		this.pointclouds = [];
	}
}
